export const viewTitle = "Отчёт по фондам";
export const viewUniqKey = "fundsReportsView";
